export default "__VITE_ASSET__BKW7YKdZ__"